import React from 'react';
import LegalPage from '@/components/LegalPage';
import usePageTitle from '@/hooks/usePageTitle';

const CookiePolicy = () => {
  usePageTitle('Cookie Policy');
  return (
  <LegalPage
    kicker="Legal"
    title="Cookie Policy"
    lastUpdated="02 July 2026"
  >
    <p>
      This Cookie Policy explains how <strong>adauraawards.com</strong> uses
      cookies and similar technologies. It should be read alongside our{' '}
      <a href="/privacy">Privacy Policy</a>.
    </p>

    <h2>1. What are cookies?</h2>
    <p>
      Cookies are small text files that a website places on your device when
      you visit. Similar technologies include browser <em>localStorage</em>,{' '}
      <em>sessionStorage</em> and pixel tags. Together we refer to these as
      “cookies”.
    </p>

    <h2>2. Cookies we set</h2>
    <ul>
      <li>
        <strong>Session cookies (strictly necessary)</strong> — <code>adaura_admin</code>,{' '}
        <code>adaura_jury</code> and <code>adaura_verify</code>. These identify a
        signed-in admin, juror or OTP-verified nominator and let us keep you
        logged in as you move between pages. They are HttpOnly, Secure and set
        with SameSite=Lax. Blocking them will break login.
      </li>
      <li>
        <strong>Preference &amp; draft cookies</strong> — <code>adaura_verify</code>{' '}
        in sessionStorage carries your name/email/mobile so the nomination form
        can auto-fill after OTP verification. Cleared when you close the tab or
        sign out.
      </li>
      <li>
        <strong>Anti-abuse cookies</strong> — a rate-limit token used to slow
        down brute-force attempts on the login and contact forms.
      </li>
    </ul>

    <h2>3. Third-party cookies</h2>
    <ul>
      <li>
        <strong>Google reCAPTCHA v3</strong> — sets cookies for its risk-scoring
        model. This is required for spam / bot protection on our public forms
        (Contact, Sponsor, Register). It cannot be opted out of without also
        disabling form submissions.
      </li>
      <li>
        <strong>Razorpay</strong> — sets its own cookies inside the checkout
        iframe when you make a payment. Governed by Razorpay’s own privacy
        &amp; cookie policy.
      </li>
    </ul>

    <p>
      We do <strong>not</strong> run third-party advertising trackers,
      re-marketing pixels, or cross-site behavioural cookies. We do not sell
      cookie-derived data.
    </p>

    <h2>4. How to control cookies</h2>
    <ul>
      <li>Most browsers allow you to view, delete and block cookies from Settings &rarr; Privacy.</li>
      <li>
        Blocking strictly-necessary cookies will prevent you from logging into
        the admin, jury or nomination portal, and will prevent payments from
        completing.
      </li>
      <li>You can clear your local session by choosing <em>Log out</em> in any signed-in surface.</li>
    </ul>

    <h2>5. Changes</h2>
    <p>
      If we materially change the cookies we set, we will update this page and
      change the “Last updated” date at the top.
    </p>

    <h2>6. Questions</h2>
    <p>
      For any cookie-related question, write to{' '}
      <a href="mailto:awards@marketingmind.co">awards@marketingmind.co</a>.
    </p>
  </LegalPage>
  );
};

export default CookiePolicy;
